import React from 'react';

const statusColors = {
  ok: 'var(--status-ok)',
  warn: 'var(--status-warn)',
  error: 'var(--status-error)',
};

const trendIcons = {
  up: '\u2191',
  down: '\u2193',
  stable: '\u2192',
};

export default function KpiRow({ kpis = [] }) {
  if (!kpis.length) return null;

  return (
    <div className="eco-kpi-row">
      {kpis.map((kpi, i) => (
        <div key={i} className="eco-kpi-card">

          <div style={{
            fontSize: 'var(--font-size-xs)',
            color: 'var(--text-muted)',
            marginBottom: 4,
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
          }}>
            {kpi.label}
          </div>
          <div style={{ display: 'flex', alignItems: 'baseline', gap: 6 }}>
            <span style={{
              fontSize: 'var(--font-size-xl)',
              fontWeight: 600,
              color: kpi.status ? statusColors[kpi.status] : 'var(--text-primary)',
            }}>
              {kpi.value}
            </span>
            {kpi.unit && (
              <span style={{ fontSize: 'var(--font-size-xs)', color: 'var(--text-muted)' }}>
                {kpi.unit}
              </span>
            )}
            {kpi.trend && (
              <span style={{
                fontSize: 'var(--font-size-sm)',
                color: kpi.trend === 'up' ? 'var(--status-ok)'
                     : kpi.trend === 'down' ? 'var(--status-error)'
                     : 'var(--text-muted)',
              }}>
                {trendIcons[kpi.trend]}
              </span>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
